module.exports = __webpack_public_path__ + "images/e58c0f16b2ef45515d92ba32338c6a01.svg";